exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-1[data-v-fe9928f2]{width:133px}.columns[data-v-fe9928f2]{width:90px}", ""]);

// exports
